//封装axios
import request from './http'
import {
  getRequestSign
} from './sign';
import global from "./common";
var accessToken = "";
// 函数节流
export function throttle(func, delay = 500) {
  var prev = Date.now();
  return function () {
    var context = this;
    var args = arguments;
    var now = Date.now();
    if (now - prev >= delay) {
      func.apply(context, args);
      prev = Date.now();
    }
  }
}
//函数防抖
export function debounce(func, delay = 500) {
  let timer;
  return function () {
    let context = this; // 注意 this 指向
    let args = arguments; // arguments中存着e

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}
//电脑端账号密码登陆
export function pcLogin(data) {
  accessToken = getRequestSign("/webLogin.do", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/webLogin.do?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//获取微信签名
export function getAppId(url) {
  accessToken = getRequestSign("/wxScanConfig", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/wechat/wxScanConfig?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      url,
    }
  });
}
//获取商家基础配置信息,商家token商家代号
export function storeBase(data) {
  accessToken = getRequestSign("/limitOfUrl", sessionStorage.getItem("storeCode"), null);
  return request({
    url: "/shopApi/author/limitOfUrl?accessToken=" + accessToken,
    method: "post",
    data,
  })
}
//获取微信请求链接
export function getUrl(data) {
  accessToken = getRequestSign("/getWxAuthorUrl", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/getWxAuthorUrl?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//获取openId和微信昵称头像
export function getOpenId(data) {
  accessToken = getRequestSign("/wxAuthorData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/wxAuthorData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//登陆获取用户Token
export function getLogin(data) {
  accessToken = getRequestSign("/wxLogin.do", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/wxLogin.do?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//海报分享登陆获取用户token
export function getShareLogin(data) {
  accessToken = getRequestSign("/shareProductWxLogin", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/shareProductWxLogin?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//手机号+验证码登陆
export function phoneLogin(data) {
  accessToken = getRequestSign("/phoneLoginByPcPhone", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/phoneLoginByPcPhone?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//登陆注册一体化
export function phoneNewLogin(data) {
  accessToken = getRequestSign("/shareProductLogin", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/shareProductLogin?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//测试登陆注册一体化
export function testNewLogin(data) {
  accessToken = getRequestSign("/phoneLoginTest", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/phoneLoginTest?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//游客登陆
export function touristLogin(data) {
  accessToken = getRequestSign("/travelLogin", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/travelLogin?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
// 账号登陆
export function disCountLogin(data) {
  accessToken = getRequestSign("/loginModelAccount", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/loginModelAccount?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//账号登陆二次验证
export function disCountLogin2(data) {
  accessToken = getRequestSign("/loginAccountSubmit", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/loginAccountSubmit?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//完善联系电话
export function disCountLogin3(data) {
  accessToken = getRequestSign("/saveCustomerMobile", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/saveCustomerMobile?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//查询海报分享记录
export function getPosterRecord(data) {
  accessToken = getRequestSign("/queryExtensionInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/queryExtensionInfo?accessToken=" + accessToken,
    method: "get",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    params: data,
  })
}
//发送短信验证码
export function getCode(data) {
  accessToken = getRequestSign("/sendSms.do", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/sendSms.do?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//注册
export function getRegister(data) {
  accessToken = getRequestSign("/register.do", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/register.do?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken")
    },
    data,
  })
}
//用户解绑
export function unBund() {
  accessToken = getRequestSign("/closeWxBind", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/closeWxBind?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    }
  })
}
//产品分类
export function showNav() {
  accessToken = getRequestSign("/classifyAll", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/product/classifyAll?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    }
  })
}
//产品列表
export function getProduct(data) {
  if (data.ppName == "") {
    delete data.ppName
  }
  accessToken = getRequestSign("/queryList.do", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  // accessToken = getRequestSign("/queryList.do","swgl","146190swgl-51114b18fb0c4017baff0f4a2d400c05");
  return request({
    url: "/shopApi/product/queryList.do?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
      // requestAuthor:"146190swgl-51114b18fb0c4017baff0f4a2d400c05",
      // requestUser:"146190swgl-5775885e4c27479a845faf34c12bc72a"
    },
    data
  })
}
//查询主产品信息
export function getMainCp(mainCp) {
  accessToken = getRequestSign("/mainProductData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/product/mainProductData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      mainCp: mainCp
    }
  })
}
//关注产品
export function collection(data) {
  accessToken = getRequestSign("/followOptional", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/product/followOptional?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//添加购物车
export function addCart(data, delay = 500) {
  accessToken = getRequestSign("/saveNormal", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/saveNormal?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//赠品加入购物车
export function addSendCart(data) {
  accessToken = getRequestSign("/savesendproduct", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/savesendproduct?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//修改购物车促销产品数量
export function changeNum(data) {
  accessToken = getRequestSign("/promotionMergy", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/promotionMergy?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//获取购物车汇总
export function getTotal(data) {
  accessToken = getRequestSign("/data", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/data?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//查询购物车数据分页
export function getCartPageData(data) {
  accessToken = getRequestSign("/queryShopCardData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/queryShopCardData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//设置备注
export function setRemarks(data) {
  accessToken = getRequestSign("/submitPh", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/submitPh?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//删除部分购物车
export function removeCart(data) {
  accessToken = getRequestSign("/remove", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/remove?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//再来一单删除部分购物车
export function newRemoveCart(data) {
  accessToken = getRequestSign("/removeOnceAgain", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/removeOnceAgain?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//清空购物车
export function removeAllCart(data) {
  accessToken = getRequestSign("/clearAll", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/clearAll?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//订单转结算
export function discount(data) {
  accessToken = getRequestSign("/settlement", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/settlement?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//订单保存
export function saveDiscount(data) {
  accessToken = getRequestSign("/save", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/settlement/save?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//查询收货地址列表
export function getAddress() {
  accessToken = getRequestSign("/queryAll", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/recevice/queryAll?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
  })
}
//删除地址
export function delAddress(uni) {
  accessToken = getRequestSign("/remove", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/recevice/remove?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      uni: uni
    }
  })
}
//查询单个地址
export function addressDetail(uni) {
  accessToken = getRequestSign("/uni", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/recevice/uni?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      uni: uni
    }
  })
}
//新增修改设为默认地址
export function changeAddress(data) {
  accessToken = getRequestSign("/optional", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/recevice/optional?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//获取个人优惠券列表
export function getCoupon(status) {
  accessToken = getRequestSign("/query", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/coupon/query?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      status: status
    }
  })
}
//代客下单登陆
export function replaceCustomer(data) {
  accessToken = getRequestSign("/standLogin", sessionStorage.getItem("storeCode"), null);
  return request({
    url: "/shopApi/author/standLogin?accessToken=" + accessToken,
    method: "post",
    data
  })
}
//修改产品单价
export function editPrice(data) {
  accessToken = getRequestSign("/mergypriceOfStand", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/mergypriceOfStand?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: data
  })
}
//获取产品分享列表 code,id
export function getShareFood(data) {
  accessToken = getRequestSign("/queryExtension", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/product/queryExtension?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: data,
  })
}
//海报分享用户记录保存
export function recordShare(data) {
  accessToken = getRequestSign("/extensionLog", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/extensionLog?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: data,
  })
}
//优惠券领取
export function receiveCoupon(code) {
  accessToken = getRequestSign("/collectCoupon", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/coupon/collectCoupon?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      code,
    }
  })
}
//分享购物车
export function shareCart(data) {
  accessToken = getRequestSign("/shareStandOrder", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/shareStandOrder?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: data
  })
}
//获取单个优惠券
export function getOneDraw(code) {
  accessToken = getRequestSign("/queryCouponData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/coupon/queryCouponData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data: {
      code,
    }
  })
}
//获取公众号二维码
export function getQrCode() {
  return request({
    url: "/shopApi/common/wxQrcodeUrl",
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
  })
}
//记录分享链接
export function saveRecord(data) {
  var newUrl = global.isTest ? "http://shopmanager.p8go.cn:8301/common/saveFlagShareUri" : "http://shopmanager.p8go.cn:8301/common/saveFlagShareUri";
  return request({
    url: newUrl,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}
//申请修改价格方案
export function changePricePlan(data) {
  accessToken = getRequestSign("/applyPriceChange", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/applyPriceChange?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取订单列表
export function getOrder(data) {
  accessToken = getRequestSign("/queryList", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/order/queryList?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//查询订单详情
export function getOrderDetail(data) {
  accessToken = getRequestSign("/orderDetails", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/order/orderDetails?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//商家查询客户订单详情
export function newGetOrderDetail(data) {
  accessToken = getRequestSign("/orderDetailInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/order/orderDetailInfo?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
    },
    data,
  })
}
//确认收货
export function goodsTake(data) {
  accessToken = getRequestSign("/orderSuccess", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/order/orderSuccess?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//再来一单
export function goodsNext(data) {
  accessToken = getRequestSign("/onceAll", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/order/onceAll?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取个人信息
export function getBaseInfo(data) {
  accessToken = getRequestSign("/query", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/customer/query?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//修改个人信息
export function saveBaseInfo(data) {
  accessToken = getRequestSign("/updateBaseInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/customer/updateBaseInfo?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//删除绑定的子账号
export function delChild(data) {
  accessToken = getRequestSign("/removeOthers", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/customer/removeOthers?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//查询积分兑换产品
export function getIntegralProduct(data) {
  accessToken = getRequestSign("/queryExchangeProduct", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/integral/queryExchangeProduct?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//积分兑换
export function exchangeProduct(data) {
  accessToken = getRequestSign("/saveIntegral", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/integral/saveIntegral?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//用户签到数据获取
export function getUserSign(data) {
  accessToken = getRequestSign("/query", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/signIn/query?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//用户签到
export function saveUserSign(data) {
  accessToken = getRequestSign("/signIn", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/signIn/signIn?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//推荐产品
export function getRecommend(data) {
  accessToken = getRequestSign("/queryRecommendData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/product/queryRecommendData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//查询首页基本数据
export function getHomeBase(data) {
  accessToken = getRequestSign("/", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/web/?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//查询首页产品数据
export function getHomeProduct(data) {
  accessToken = getRequestSign("/webProductData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/web/webProductData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//首页分类轮播图查询产品数据
export function getCommonData(data) {
  accessToken = getRequestSign("/productData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/web/productData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//在线支付
export function onLinePay(data) {
  accessToken = getRequestSign("/payRequest", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/settlement/payRequest?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//全选订单转结算
export function allPayment(data) {
  accessToken = getRequestSign("/settlementBySelectAll", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/settlementBySelectAll?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取秒杀详情
export function getSecDetail(data) {
  accessToken = getRequestSign("/queryInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/seckill/queryInfo?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取新秒杀详情
export function getNewSecDetail(data) {
  accessToken = getRequestSign("/queryInfoByTime", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/seckill/queryInfoByTime?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//秒杀加入购物车
export function SecAddCart(data) {
  accessToken = getRequestSign("/saveSeckillData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/saveSeckillData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//所有秒杀进度
export function getSecProgress(data) {
  accessToken = getRequestSign("/flushSeckillData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/seckill/flushSeckillData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//所有秒杀新进度
export function getNewSecProgress(data) {
  accessToken = getRequestSign("/flushSeckillDataByTime", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/seckill/flushSeckillDataByTime?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//首页联合查询产品
export function getUnion(data) {
  accessToken = getRequestSign("/queryUnionProductData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/web/queryUnionProductData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取搜索关键词
export function getKeyWord(data) {
  accessToken = getRequestSign("/queryKeyWord", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/common/queryKeyWord?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//记录库存增加
export function addStock() {
  accessToken = getRequestSign("/shopcardSeckillExit", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/shopcardSeckillExit?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
  })
}
//回复订单信息
export function replyNews(data) {
  return request({
    url: "/shopApi/common/sendTextMessage",
    method: "post",
    data,
  })
}
//获取订单概要
export function replyData(data) {
  return request({
    url: "/shopApi/common/orderSimpleData",
    method: "get",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
    },
    params: data,
  })
}
//解除绑定(退出登录)
export function removeDiscount() {
  accessToken = getRequestSign("/closeWxBind", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/closeWxBind?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
  })
}
//获取缺货产品
export function getStock(data) {
  accessToken = getRequestSign("/queryNewProductPaperData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/product/queryNewProductPaperData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取联盟性购物车数据
export function getNewCart(data) {
  accessToken = getRequestSign("/queryShopCardDataInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/queryShopCardDataInfo?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//超200条购物车数据转后台结算
export function goDiscount(data) {
  accessToken = getRequestSign("/settlementBySelectAll", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/settlementBySelectAll?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取结算订单数据
export function getDiscount(data) {
  accessToken = getRequestSign("/backUpSettlementData", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/backUpSettlementData?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
export function chooseSuit(data) {
  accessToken = getRequestSign("/selectPromotionSend", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/shop/selectPromotionSend?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//pc端注册
export function userRegister(data) {
  accessToken = getRequestSign("/WebRegister.do", sessionStorage.getItem("storeCode"), null);
  return request({
    url: "/shopApi/author/WebRegister.do?accessToken=" + accessToken,
    method: "post",
    data,
  })
}
//pc端修改密码
export function updatePassword(data) {
  accessToken = getRequestSign("/updateLoginPwd.do", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/author/updateLoginPwd.do?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取公司介绍
export function getCompany(data) {
  accessToken = getRequestSign("/companyIntroduce", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/customer/companyIntroduce?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取配送介绍
export function getDelivery(data) {
  accessToken = getRequestSign("/deliveryInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/customer/deliveryInfo?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//获取收货介绍
export function getReceiving(data) {
  accessToken = getRequestSign("/receivingInfo", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url: "/shopApi/customer/receivingInfo?accessToken=" + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data,
  })
}
//更换账号
export  function  exchangeDiscount(data) {
  accessToken = getRequestSign("/changeStoreAccount", sessionStorage.getItem("storeCode"), sessionStorage.getItem("storeToken"));
  return request({
    url:'/shopApi/author/changeStoreAccount?accessToken=' + accessToken,
    method: "post",
    headers: {
      requestAuthor: sessionStorage.getItem("storeToken"),
      requestUser: sessionStorage.getItem("token")
    },
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js